import styled from 'styled-components'
import InputMask from "react-input-mask";

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 8px;
`;

export const StyledInput = styled(InputMask)`
    height: 38px;
    padding: 12px 16px;
    background: #F7F7FC;
    border-radius: 8px;
    border: none;
    align-self: stretch;
    
    &:focus {
      box-shadow: 0 0 0 0;
      border: 0 none;
      outline: 0;
    }

    &::placeholder {
      color: #A0A3BD;
    }

    @media screen and (max-width: 600px) {
      height: 32px;
    }
`;

export const Label = styled.label`
    width: fit-content;
    font-family: "InterTight-Bold", Helvetica;
    font-weight: 700;
    font-size: 14px;
    letter-spacing: 1px;
    line-height: 16px;
    font-style: normal;
    color: #195AB4;
    white-space: nowrap;
`;

export const ErrorMessage = styled.p`
  font-size: 12px;
  font-family: "Inter Tight", Helvetica;
  font-weight: 500;
  color: #E11900;
`;